import reducers from './reducers.js';
import fetch from '../../fetch.js';
import { NOTIFY_TYPE, notifyError, notifySuccess } from '../../../shared';
import environment from '../../../environment';

const greenfield = (() => {
    const getGreenfield = (id) => {
        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/greenfield/${id}`,
            async: false
        }).then(reducers.greenfield, notifyError);
    };

    return {
        getGreenfield
    };
})();

export default greenfield;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/greenfield/index.js